<div class="tab-pane with-scroll fade active show" id="insurance" role="tabpanel" aria-labelledby="insurance-tab">
    <div class="no-data with-border d-none">
        <img src="./assets/images/icons/no-data-img.svg" alt="">
        <h4>Looks like there are no Sub-Offices added yet.</h4>
        <p>Get started by <a href="" id="createNewGroup">Create New Group</a></p>
    </div>
    <div class="filter-body">
        <div *ngIf="showFilter" class="filter">
            <div class="row" [formGroup]="filterForm">

                <div class="col">
                    <input type="text" class="form-control" formControlName="companyName" id="tpacn"
                        placeholder="TPA Company Name"appPreventFirstSpace>
                </div>

                <div class="col">
                    <app-single-select [isListing]="true" uid="countryId" [searchShow]=true [dataArr]="countryList"
                        (selectedEvent)="selectedValue($event,'country');" label="countryName"
                        [selectedData]="filterForm.value.country" [placeholder]="'Country'">
                    </app-single-select>
                </div>
                <div class="col">
                    <app-single-select [isListing]="true" uid="regulatoryId" [dataArr]="regulatorList"
                        (selectedEvent)="selectedValue($event,'regulator');" label="regulatoryAuthority"
                        [selectedData]="filterForm.value.regulator" [placeholder]="'Regulator'">
                    </app-single-select>
                </div>
                <div class="col">
                    <input type="text" class="form-control" formControlName="receiver" id="tpacn1"
                    placeholder="Payer Code" appPreventFirstSpace>
                </div>

                <div class="col-2 d-flex">
                    <button id="btnGroupApplyInsurance" type="button" class="btn btn-dark-blue"
                        (click)="filterOnClick()" [ngClass]="{'disabled':filterForm.invalid}">APPLY</button>
                    <a class="reset-btn" (click)="resetForm()"><span></span>Reset</a>
                </div>

                <div class="col-2" *ngIf=" checkPermission('addPayer')">
                    <button id="btnGroupAddNewInsurance" (click)="openAddInsurance()" type="button"
                        class="btn btn-primary float-end" data-bs-toggle="modal">
                        ADD New Payer</button>
                </div>
            </div>
        </div>
    </div>

    <div class="table-container table-responsive">
        <table class="table table-list">
            <caption class="d-none">Insurance list table body</caption>
            <thead>
                <tr>
                    <th scope="col">PAYER#<span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('payerId')"><a class="{{columnSort['payerId'].sortType}} "></a></span></th>
                    <th scope="col">TPA Company Name<span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('payerName')"><a class="{{columnSort['payerName'].sortType}} "></a></span></th>
                    <th scope="col">Country <span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('countryName')"><a class="{{columnSort['countryName'].sortType}} "></a></span></th>
                    <th scope="col">Regulator<span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('regulatoryAuthorityCode')"><a class="{{columnSort['regulatoryAuthorityCode'].sortType}} "></a></span></th>
                    <th scope="col">Payer Code<span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('payerCode')"><a class="{{columnSort['payerCode'].sortType}} "></a></span></th>
                    <th scope="col">Insurance Company<span *ngIf="insuranceList.length" class="sort-order"  (click)="sortColumn('InsuranceCompany')"><a class="{{columnSort['InsuranceCompany'].sortType}} "></a></span></th>
                    <th scope="col">Actions</th>


                </tr>
            </thead>
            <tbody *ngIf=" insuranceList.length">
                <tr *ngFor="let item of insuranceList">
                    <td>{{item?.payerId || '-'}}</td>
                    <td>{{item?.payerName || '-'}}</td>
                    <td>{{item.countryName || '-'}}</td>
                    <td>{{item.regulatoryAuthorityCode || '-'}}</td>
                    <td>{{item?.payerCode || '-'}}</td>
                    <td>{{item?.InsuranceCompany?.[0] || '-'}}<span *ngIf="(item?.InsuranceCompanyCount != 0 && item?.InsuranceCompanyCount != null && item?.InsuranceCompany?.length!=1)" data-toggle="tooltip" data-placement="top" title="{{item?.InsuranceCompany?.[0] || '-'}}">
                        <a class="" *ngIf="item?.InsuranceCompanyCount != 1" >  +{{item?.InsuranceCompanyCount}}</a></span></td>
                    <td>
                        <ul class="actions">
                            <li *ngIf=" checkPermission('editPayer')">
                                <a *ngIf="showFilter" id="ProviderEdit" data-bs-toggle="modal" (click)="showEditPayerPopup(item.payerId)" class="edit-icon tool-wrap position-relative" >
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> Edit </div>
                                      </div>
                                </a>
                            </li>
                            <li *ngIf=" checkPermission('viewPayer')">
                                <a data-bs-toggle="modal" class="view tool-wrap position-relative" (click)="showPayerDetailsPopup(item.payerId)">
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> View </div>
                                      </div>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>



            </tbody>

        </table>
        <div class="no-data with-border" *ngIf="!insuranceList.length">
            <img src="./assets/images/icons/no-data-img.svg" alt="">
            <p>No Results Found</p>

        </div>

    </div>

    <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)" >
    </app-navigation>
</div>
<app-add-insurance *ngIf="addInsurance" [editPayerId]="editPayerId"   (close)="closePopup();addInsurance=$event; editPayerId=null"></app-add-insurance>
<app-payer-view *ngIf="isViewPayer"  [payerId]="editPayerId" (close)="closePopup();isViewPayer=$event;editPayerId=null;" (editPayer)="manageEdit()"></app-payer-view>
